import { getApiAnalyticsByFilterType } from "@/generated";
import { handleApiResponseAssertData } from "./handleApiResponseAssertData";

export const apiAnalytics = {
    getDashboardAnalytics: async (
        filter_type: "internal" | "external" | "all",
    ) =>
        handleApiResponseAssertData(() =>
            getApiAnalyticsByFilterType({
                path: { filter_type: filter_type },
            }),
        ),
};
